import { Question } from './Info';
import { Answer } from './Info';

export const verificationQuestions: Question[] = [
    // Utilities Section
    {
        internalId: 1,
        id: "550e8400-e29b-41d4-a716-446655440000",
        description: "Utilities",
        maxScore: 0,
        parentQuestionId: 0,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 0,
        required: false,
        questionType: 3
    },
    {
        internalId: 2,
        id: "550e8400-e29b-41d4-a716-446655440001",
        description: "Can you please verify the electrical service size currently supplied to the demised space? Can you please verify the condition of the electrical panel and meter and how recently it was installed or upgraded?",
        maxScore: 5,
        parentQuestionId: 1,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 1,
        required: false,
        questionType: 3
    },
    {
        internalId: 3,
        id: "550e8400-e29b-41d4-a716-446655440002",
        description: "Can you please verify the water service size currently supplying the demised space? Can you please verify the condition of the water meter and shut-off? The accuracy of this information is especially important for restaurant and foodservice tenants.",
        maxScore: 5,
        parentQuestionId: 1,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 1,
        required: false,
        questionType: 3
    },
    {
        internalId: 4,
        id: "550e8400-e29b-41d4-a716-446655440003",
        description: "Can you please verify the gas service size currently supplying the demised space? Can you please verify the condition of the gas meter and shut-off? The accuracy of this information is especially important for restaurant and foodservice tenants.",
        maxScore: 5,
        parentQuestionId: 1,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 1,
        required: false,
        questionType: 3
    },
    {
        internalId: 5,
        id: "550e8400-e29b-41d4-a716-446655440004",
        description: "Can you verify if any high-efficiency heating/cooling/water/etc. equipment has been installed in this building and is currently being used to provide service to this demised space? Please provide make/model of relevant equipment and year it was put into service.",
        maxScore: 10,
        parentQuestionId: 1,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 1,
        required: false,
        questionType: 3
    },
    {
        internalId: 6,
        id: "550e8400-e29b-41d4-a716-446655440005",
        description: "Can you verify that the building and the demised space receives power from renewable resources? Please provide corroborating documentation of renewable power sourcing.",
        maxScore: 10,
        parentQuestionId: 1,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 1,
        required: false,
        questionType: 3
    },

    // Owner Profile Section
    {
        internalId: 7,
        id: "550e8400-e29b-41d4-a716-446655440006",
        description: "Owner Profile",
        maxScore: 0,
        parentQuestionId: 0,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 0,
        required: false,
        questionType: 3
    },
    {
        internalId: 8,
        id: "550e8400-e29b-41d4-a716-446655440007",
        description: "Please let us know if you are interested in creating an 'Owner Profile' for Parslii users. This could be photos/video/text introducing you and your organization as the property owners which could go a long way in reassuring tenants that there are people there that care about their reputation and providing service to their tenants.",
        maxScore: 10,
        parentQuestionId: 7,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 1,
        required: false,
        questionType: 3
    },
    {
        internalId: 9,
        id: "550e8400-e29b-41d4-a716-446655440008",
        description: "During the Covid pandemic did you give rent relief or work out other concessions with any of your commercial tenants? If so can you provide corroborating documentation or contact information for a current or prior tenant that received it for confidential verification purposes?",
        maxScore: 10,
        parentQuestionId: 7,
        createdBy: 1,
        createdUtc: new Date("2024-01-01T00:00:00Z"),
        answerType: 1,
        required: false,
        questionType: 3
    }
];

export const sampleAnswers: Answer[] = [
    {
        internalId: 1,
        id: "ANS_001",
        description: "Yes",
        score: 10,
        questionId: 1,
        createdBy: 1,
        createdUtc: new Date()
    },
    {
        internalId: 2,
        id: "ANS_002",
        description: "No",
        score: 0,
        questionId: 1,
        createdBy: 1,
        createdUtc: new Date()
    },
    {
        internalId: 3,
        id: "ANS_003",
        description: "Less than 5 years old",
        score: 15,
        questionId: 2,
        createdBy: 1,
        createdUtc: new Date()
    },
    {
        internalId: 4,
        id: "ANS_004",
        description: "5-10 years old",
        score: 10,
        questionId: 2,
        createdBy: 1,
        createdUtc: new Date()
    },
    {
        internalId: 5,
        id: "ANS_005",
        description: "More than 10 years old",
        score: 5,
        questionId: 2,
        createdBy: 1,
        createdUtc: new Date()
    }
];